import React from 'react';

export const money = (v, dec = 0) => '$' + Number(v || 0).toLocaleString('es-AR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
export const moneyK = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e6) return '$' + (n / 1e6).toLocaleString('es-AR', { maximumFractionDigits: 1 }) + ' M';
  if (Math.abs(n) >= 1e3) return '$' + Math.round(n / 1e3).toLocaleString('es-AR') + ' mil';
  return money(n);
};
export const fecha = (d) => {
  if (!d) return '—';
  const s = String(d).slice(0, 10).split('-');
  return `${s[2]}/${s[1]}/${s[0]}`;
};
export const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
export const mesLabel = (m) => { const [y, mm] = String(m).split('-'); return `${MESES[Number(mm) - 1]} ${String(y).slice(2)}`; };
export const hoy = () => new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);

export const ESTADO_COBRO = {
  pendiente: { label: 'Pendiente', color: '#f59e0b', bg: 'rgba(245,158,11,0.15)' },
  vencido: { label: 'Vencido', color: '#ef4444', bg: 'rgba(239,68,68,0.15)' },
  informado: { label: 'Informado', color: '#0ea5e9', bg: 'rgba(14,165,233,0.15)' },
  pagado: { label: 'Pagado', color: '#22c55e', bg: 'rgba(34,197,94,0.15)' },
  anulado: { label: 'Anulado', color: '#64748b', bg: 'rgba(100,116,139,0.15)' },
};
export const ESTADO_RENOVACION = {
  por_preparar: { label: 'Por preparar', color: '#f59e0b' },
  preparada: { label: 'Preparada', color: '#0ea5e9' },
  enviada: { label: 'Enviada', color: '#a855f7' },
  renovada: { label: 'Renovó', color: '#22c55e' },
  no_renovo: { label: 'No renovó', color: '#ef4444' },
  en_gracia: { label: 'Período de gracia', color: '#f97316' },
};

export const Badge = ({ label, color, bg }) => (
  <span className="badge" style={{ background: bg || 'transparent', color: color || 'var(--text-secondary)', border: bg ? 'none' : '1px solid var(--border)', fontSize: 11 }}>{label}</span>
);

export const Kpi = ({ label, value, sub, color = 'var(--text-primary)', onClick }) => (
  <div className="card" style={{ padding: '14px 16px', cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
    <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600 }}>{label}</div>
    <div style={{ fontSize: 24, fontWeight: 800, marginTop: 4, color }}>{value}</div>
    {sub && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{sub}</div>}
  </div>
);

export const Title = ({ children, right }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 18, flexWrap: 'wrap' }}>
    <h1 style={{ fontSize: 24, fontWeight: 800 }}>{children}</h1>
    {right}
  </div>
);

export const Empty = ({ children }) => <p style={{ color: 'var(--text-muted)', fontSize: 13, padding: '12px 0' }}>{children}</p>;
